// Returns a debounced version of fn that delays invocation until after delayMs
// have elapsed since the last call. Use with useMemo to avoid recreating on
// every render: const handler = useMemo(() => debounce(fn, 300), [fn])
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debounce<T extends (...args: any[]) => void>(
  fn: T,
  delayMs: number,
): (...args: Parameters<T>) => void {
  let timeoutId: ReturnType<typeof setTimeout> | undefined
  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn(...args), delayMs)
  }
}
